import getAccessToken from '../helpers/get-access-token';

const checkLogin = () => {
    const isLoggedIn = getAccessToken();
    return isLoggedIn;
};

export default checkLogin;
